var custom_navigation = {
  // Arrow SVG constant to avoid duplication
  ARROW_SVG: '<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 9L1 5L5 1" stroke="var(--color-header-links, --color-accent)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
  
  createNavigation: function (menu_key) {
    let setDate = custom.getAttribute('SETDATE');
    if (setDate) {
      const date = new Date(setDate); // Create a new Date object representing the current date and time
      const timestamp = date.getTime(); // Get the timestamp in milliseconds
      menu_key += '_' + timestamp.toString().slice(0, -3);
    }
    custom.updateLocale();
    const localeKey = theme.settings.locale ? theme.settings.locale : 'default';
    const countryKey = theme.settings.customer_country_code ? theme.settings.customer_country_code : 'default';
    const customerIdKey = theme.customer_id ? theme.customer_id : 'guest';
    let storageKey = "navigation_" + menu_key + "_" + localeKey + "_" + countryKey.toLowerCase() + "_" + customerIdKey;
    let currentMenuStorage = sessionStorage.getItem(storageKey);
    //Check if the menu has been stored for over 5 minutes, if so then delete the storage and allow it to resave
    let now = Date.now();
    let before = sessionStorage.getItem("navigation_time");
    if (before) {
      let diff = now - before;
      if (diff > 300000) {
        sessionStorage.removeItem(storageKey);
        sessionStorage.removeItem("navigation_time");
      }
    }

    if (currentMenuStorage && !setDate) {
      let data = JSON.parse(currentMenuStorage);
      this.createDesktopNav(data);
      this.createMobileNav(data);
    } else {
      let fetchUrl = productCardElems.parsePageUrl("metaobject-api/nosto_navigation*" + menu_key);
      fetch(fetchUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text(); // Get as text first
        })
        .then((text) => {
          // Clean the JSON string by removing/replacing control characters
          const cleanedText = text.replace(/[\x00-\x1F\x7F]/g, ''); // Remove control chars
          // Or more targeted: text.replace(/[\n\r\t]/g, ''); // Remove newlines, returns, tabs
          return JSON.parse(cleanedText);
        })
        .then((result) => {
          if (custom.getAttribute("debugnav")) {
            console.log('nav api result:', result);
          }
          if (result && result.nosto_navigation && result.nosto_navigation.length > 0) {
            let data = result.nosto_navigation[0].data;
            if (data && data.nav_categories) {
              sessionStorage.setItem(storageKey, JSON.stringify(data));
              sessionStorage.setItem("navigation_time", now);
              this.createDesktopNav(data);
              this.createMobileNav(data);
            }
          }
        });
    }
  },
  createDesktopNav: function (json) {
    custom_navigation.logIfNavigationIsEmpty(json);
    let downArrow = `<svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.75 1.5L3.75 4.5L0.75 1.5" stroke="var(--color-header-links, --color-accent)" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>`;
    let menuWrapper = document.createElement("ul");
    menuWrapper.setAttribute("class", "thb-full-menu");
    menuWrapper.setAttribute("role", "menubar");
    json.nav_categories.map((item) => {
      var li = document.createElement("li");
      li.setAttribute("role", "none");
      var a = document.createElement("a");
      a.setAttribute("role", "menuitem");
      let itemUrl = window.Shopify.routes.root.slice(0, -1) + item.url
        ? window.Shopify.routes.root.slice(0, -1) + item.url
        : "#";
      a.setAttribute("href", itemUrl);
      a.setAttribute("title", item.name);
      a.textContent = item.name;
      let itemColor = item.color;
      if (itemColor) {
        a.setAttribute("style", `color:${itemColor}`);
      }
      li.appendChild(a);
      let categories = item.categories;

      if (
        categories &&
        categories.length > 0 &&
        item.type == "navigation_categories"
      ) {
        a.innerHTML += downArrow;
        li.setAttribute(
          "class",
          "menu-item-has-children menu-item-has-megamenu"
        );
        var mainDiv = document.createElement("div");
        mainDiv.setAttribute("class", "sub-menu mega-menu-container");
        var nestedUl = document.createElement("ul");
        nestedUl.setAttribute("class", "mega-menu-columns");
        categories.map((category) => {
          if (category.type == "navigation_promos") {
            let promoTitle = category.promo_title;
            let promoImage = category.promo_image;
            let promoSubTitle = category.promo_subtitle
              ? category.promo_subtitle
              : "";
            let promoLink = custom.fetchLinkWithLocale(category.promo_url);
            let altImage = (window.Shopify && window.Shopify.shop ? window.Shopify.shop : "") + " " + category.promo_title;
            if (promoTitle && promoImage) {
              nestedUl.innerHTML += `<li>
                      <div class="mega-menu-promotion">
                        <div class="mega-menu-promotion--image">
                          <img class="no-blur lazyautosizes lazyloaded" width="350" height="220" data-sizes="auto" src="${promoImage}" data-srcset="${promoImage}" fetchpriority="low" alt="${altImage}" style="object-position: 50.0% 50.0%;" sizes="189px" srcset="${promoImage}">
                        </div>
                        <div class="mega-menu-promotion--content"><span class="h6">${promoTitle}</span><p>${promoSubTitle}</p></div><a href="${promoLink}" class="mega-menu-promotion--link"></a></div>
                    </li>`;
            }
          } else {
            let categoryLi = document.createElement("li");
            categoryLi.setAttribute("role", "none");
            if (category.mobile_only == 'true') {
              categoryLi.setAttribute('class', 'mobile_only');
            }
            let categoryTitleElem = document.createElement("a");
            categoryTitleElem.textContent = category.title;
            categoryTitleElem.href =
              window.Shopify.routes.root.slice(0, -1) + category.url
                ? window.Shopify.routes.root.slice(0, -1) + category.url
                : "#";

            categoryTitleElem.setAttribute(
              "class",
              "mega-menu-columns__heading navigation_level2"
            );
            categoryTitleElem.setAttribute("role", "menuitem");
            let categoryColor = category.color;
            if (categoryColor) {
              categoryTitleElem.setAttribute("style", `color:${categoryColor}`);
            }
            categoryLi.appendChild(categoryTitleElem);
            let categoryUl = document.createElement("ul");
            categoryUl.setAttribute("role", "menu");
            let items = category.items;
            items.map((item) => {
              let nestedLi = document.createElement("li");
              if (item.mobile_only == 'true') {
                nestedLi.setAttribute('class', 'mobile_only');
              }
              let nestedLink = document.createElement("a");
              nestedLink.setAttribute("class", "navigation_level3");
              nestedLink.setAttribute("role", "menuitem");
              nestedLink.textContent = item.name;
              nestedLink.href =
                window.Shopify.routes.root.slice(0, -1) + item.url
                  ? window.Shopify.routes.root.slice(0, -1) + item.url
                  : "#";
              let linkColor = item.color;
              if (linkColor) {
                nestedLink.setAttribute("style", `color:${linkColor}`);
              }
              let nav4links = item.nav4_links;
              if(nav4links && nav4links.length > 0) {
                nestedLink.href = "#"; // Prevent default link behavior if there are nav4 links
                nestedLink.setAttribute("onclick", "custom_navigation.toggleNav4Links(event, this)");
                nestedLink.innerHTML += ' <span class="nav4-arrow">' + this.ARROW_SVG + '</span>'; // Arrow when closed
              }
              nestedLi.appendChild(nestedLink);
              if(nav4links && nav4links.length > 0) {
                let nav4Ul = document.createElement("ul");
                nav4Ul.setAttribute("style", "display:none;");
                nav4links.map((nav4link) => {
                  let nestedLi4 = custom_navigation.createNavLink(nav4link);
                  nav4Ul.appendChild(nestedLi4);
                });
                nestedLi.appendChild(nav4Ul);
              }
              categoryUl.appendChild(nestedLi);
            });
            categoryLi.appendChild(categoryUl);
            nestedUl.appendChild(categoryLi);
          }
        });
        mainDiv.appendChild(nestedUl);

        li.appendChild(mainDiv);
      }

      // Add mouseenter listener to close nav4 submenus when entering any level 1 item
      li.addEventListener('mouseenter', function() {
        // Close all nav4 submenus in all megamenus
        document.querySelectorAll('.thb-full-menu .navigation_level3 + ul').forEach(function(nav4Ul) {
          if (nav4Ul.style.display === 'block') {
            nav4Ul.style.display = 'none';
            let arrow = nav4Ul.parentElement.querySelector('.nav4-arrow');
            if (arrow) arrow.style.transform = 'rotate(270deg)';
          }
        });

        // Remove focus from any focused element within menus to allow hover to work
        let focusedElement = document.activeElement;
        if (focusedElement && focusedElement.closest('.thb-full-menu')) {
          focusedElement.blur();
        }
      });

      // Append the list item to the unordered list
      menuWrapper.appendChild(li);
    });

    // Add mouseleave listener to the menu wrapper to close all nav4 submenus when leaving the menu
    menuWrapper.addEventListener('mouseleave', function() {
      document.querySelectorAll('.thb-full-menu .navigation_level3 + ul').forEach(function(nav4Ul) {
        if (nav4Ul.style.display === 'block') {
          nav4Ul.style.display = 'none';
          let arrow = nav4Ul.parentElement.querySelector('.nav4-arrow');
          if (arrow) arrow.style.transform = 'rotate(270deg)';
        }
      });
    });

    let fullMenu = document.getElementById("nosto-menu-desktop");
    if (fullMenu) {
      fullMenu.innerHTML = "";
      fullMenu.appendChild(menuWrapper);
    }
  },
  toggleNav4Links: function (event, element) {
    event.preventDefault(); // Prevent default link behavior
    event.stopPropagation(); // Stop event from bubbling up
    let parentLi = element.parentElement;
    let nav4Ul = parentLi.querySelector("ul");
    let arrow = element.querySelector(".nav4-arrow");
    if (nav4Ul) {
      if (nav4Ul.style.display === "block") {
        nav4Ul.style.display = "none"; // Hide the submenu
        if (arrow) arrow.style.transform = "rotate(270deg)"; // Down arrow when closed
      } else {
        nav4Ul.style.display = "block"; // Show the submenu
        if (arrow) arrow.style.transform = "rotate(90deg)"; // Up arrow when open
      }
    }
    // Remove focus to allow hover to work properly
    element.blur();
  },
  createNavLink: function (item) { 
    let nestedLi = document.createElement("li");
    let nestedLink = document.createElement("a");
    nestedLink.setAttribute("class", "navigation_level4");
    nestedLink.setAttribute("role", "menuitem");
    nestedLink.textContent = item.name;
    nestedLink.href =
      window.Shopify.routes.root.slice(0, -1) + item.url
        ? window.Shopify.routes.root.slice(0, -1) + item.url
        : "#";
    let linkColor = item.text_color;
    if (linkColor) {
      nestedLink.setAttribute("style", `color:${linkColor}`);
    }
    nestedLi.appendChild(nestedLink);
    return nestedLi;
  },
  createMobileNav: function (json) {
    custom_navigation.logIfNavigationIsEmpty(json);
    let mobileDiv = document.getElementById("mobile-menu-drawer--inner");
    if (mobileDiv) {
      mobileDiv.innerHTML = "";
      let menuHTML = "";
      json.nav_categories.map((item, idx) => {
        let categories = item.categories_mobile;
        if (!categories || categories.length == 0) {
          categories = item.categories;
        }
        let detailsHTML = this.createBackLink(item.name);
        if (categories && categories.length > 0) {
          categories.map((category) => {
            if (category.type == "navigation_promos") {
              let promoTitle = category.promo_title;
              let promoImage = category.promo_image;
              let promoSubTitle = category.promo_subtitle
                ? category.promo_subtitle
                : "";
              let promoLink = custom.fetchLinkWithLocale(category.promo_url);
              if (promoTitle && promoImage) {
                detailsHTML += `<li>
                        <div class="mega-menu-promotion">
                          <div class="mega-menu-promotion--image">
                            <img class="no-blur lazyautosizes lazyloaded" width="350" height="220" data-sizes="auto" src="${promoImage}" data-srcset="${promoImage}" fetchpriority="low" alt="" style="object-position: 50.0% 50.0%;" sizes="189px" srcset="${promoImage}">
                          </div>
                          <div class="mega-menu-promotion--content"><span class="h6">${promoTitle}</span><p>${promoSubTitle}</p></div><a href="${promoLink}" class="mega-menu-promotion--link"></a></div>
                      </li>`;
              }
            } else {
              let links = category.items;
              let linksHTML = this.createBackLink(category.title);
              if (links && links.length > 0) {
                links.map((link) => {
                  linksHTML += this.createLink(link);
                });
                let details = this.createDetails(category.title, linksHTML);
                detailsHTML += details;
              } else {
                if (category.title) {
                  detailsHTML += `<li>
               <a href="${window.Shopify.routes.root.slice(0, -1) + category.url
                    }" title="${category.title}" class="${category.type}" role="menuitem">${category.title} </a>
               </li>`;
                }
              }
            }

          });
          menuHTML += this.createDetails(item.name, detailsHTML);
        } else {
          menuHTML += this.createLink(item);
        }
      });
      mobileDiv.innerHTML = `
    <ul class="mobile-menu">
      ${menuHTML}
    </ul>`;
      let themeHeader = document.querySelector("theme-header");
      themeHeader.addSummaryListener();
    }

  },
  createDetails: function (title, linksHTML) {
    let detailsHTML = `<li>
        <details class="link-container submenu-open">
          <summary class="parent-link">
          ${title}
            <span class="link-forward">
              <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.999999 13L7 7L1 1" stroke="var(--color-header-links, --color-accent)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </span>
          </summary>
          <ul class="sub-menu">
            ${linksHTML}
          </ul>
        </details>
      </li>`;
    return detailsHTML;
  },
  createBackLink: function (title) {
    let link = `
      <li class="parent-link-back">
        <button class="parent-link-back--button">
          <span>
            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 9L1 5L5 1" stroke="var(--color-header-links, --color-accent)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </span> 
          ${title}
        </button>
      </li>`;
    return link;
  },
  createLink: function (link) {
    let linkColor = "";
    if (link.color) {
      linkColor = ` style="color:${link.color}"`;
    }
    let linkHTML = "";
    let nav4links = link.nav4_links;
    if(nav4links && nav4links.length > 0) {
      linkHTML = `<li class="has-nav4-links">`;
      linkHTML += `<a${linkColor} href="#" title="${link.name}" role="menuitem" onclick="custom_navigation.toggleMobileNav4Links(event, this)">${link.name} <span class="nav4-arrow">${this.ARROW_SVG}</span></a>`;
      
      linkHTML += `<ul class="nav4-mobile-list">`; // Start the ul for nav4 links
      nav4links.map((nav4link) => {
      linkHTML += `<li><a href="${window.Shopify.routes.root.slice(0, -1) + nav4link.url}" title="${nav4link.name}" style="font-size: 0.9em;">${nav4link.name}</a></li>`;  
      });
      linkHTML += `</ul>`; // End the ul for nav4 links
    } else {
      linkHTML = `<li>`;
      linkHTML += `<a${linkColor} href="${window.Shopify.routes.root.slice(0, -1) + link.url
      }" title="${link.name}" role="menuitem">${link.name} </a>`;
      
    }
    linkHTML += `</li>`;
    return linkHTML;
  },
  toggleMobileNav4Links: function (event, element) {
    event.preventDefault(); // Prevent default link behavior
    let parentLi = element.parentElement;
    let nav4Ul = parentLi.querySelector("ul");
    let arrow = element.querySelector(".nav4-arrow");
    if (nav4Ul) {
      if (nav4Ul.style.display === "block") {
        nav4Ul.style.display = "none"; // Hide the submenu
        element.style.borderBottom = "1px solid rgba(0, 0, 0, 0.08)"; // Restore border when closed
        parentLi.style.borderBottom = "none"; // Remove li border when closed
        if (arrow) arrow.style.transform = "rotate(270deg)"; // Down arrow when closed
      } else {
        nav4Ul.style.display = "block"; // Show the submenu
        element.style.borderBottom = "none"; // Remove border from link when open
        parentLi.style.borderBottom = "1px solid rgba(0, 0, 0, 0.08)"; // Add border to li when open
        if (arrow) arrow.style.transform = "rotate(90deg)"; // Up arrow when open
      }
    }
  },
  cleanNav: function (str) {
    let cleanedString = str.replace(/[\t\n\r]+/g, "");
    //remove tabs
    cleanedString = cleanedString.replace(/\t/g, "");
    cleanedString = cleanedString.replace(/ {2,}/g, " "); // Strip 2 or more spaces
    cleanedString = cleanedString.replace(/, ]/g, ']');
    cleanedString = cleanedString.replace(/,]/g, ']');//There's a scenario where the json object is not valid and has a trailing comma due to the date being invalid but liquid is checking for last item in loop
    // Parse the cleaned string as JSON
    try {
      const parsedJSON = JSON.parse(cleanedString);
      return parsedJSON;
    } catch (error) {
      console.error("Invalid JSON string:", error);
      return null; // Or you can throw an error or handle it as needed
    }
  },
  logIfNavigationIsEmpty: function (navJson) {
    if (navJson == null || !navJson.nav_categories || navJson.nav_categories.length == 0) {
      const error = new Error("Navigation is Empty");
      error.dd_fingerprint = "navigation-is-empty";
      var navData = navJson
      if (navJson == null) {
        navData = "null";
      } else if (Object.keys(navJson).length === 0) {
        navData = "empty";
      }
      const additionalAttributes = { "navigationData": navData };
      custom.logErrorToDatadog(error, additionalAttributes);
    }
  }
}